import { forwardRef } from 'react';

interface CustomMarkButtonProps {
  icon: string;
  css?: string;
  selected: boolean;
  setSelected: (value: boolean) => void;
  text?: string;
}

export const CustomMarkButton = forwardRef<HTMLButtonElement, CustomMarkButtonProps>(({ icon, css, selected, setSelected }, ref) => {
  return (
    <button
      ref={ref}
      className={`${css} ${selected ? 'active' : ''}`}
      onMouseDown={(event) => {
        event.preventDefault();
        setSelected(!selected);
      }}
    >
      <i className={`fa-regular fa-${icon}`} />
    </button>
  );
});
